"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SpinnerLoader_scss_1 = __importDefault(require("./SpinnerLoader.scss"));
function SpinnerLoader() {
    return react_1.default.createElement("div", { className: SpinnerLoader_scss_1.default.spinner });
}
exports.default = SpinnerLoader;
